import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Collapse, Input, Label } from "reactstrap";
import { getSettingByKey, toArray } from "../../../../helpers/common";

const WorkExperience = ({
  onFilterChange,
  handleClearFilter,
  searchParams,
}) => {
  const [toggleSecond, setToggleSecond] = useState(false);
  const [checked, setChecked] = useState([]);

  // Extract workExperiences from URL parameter
  const workExperiencesParam = searchParams.get("workExperiences");

  const settings = useSelector((state) => state.settings.data);

  // Helper function to turn dynamic strings into a clean array
  const toArray = (str, delim) =>
    str
      ? str
          .split(delim)
          .map((s) => s.trim())
          .filter(Boolean)
      : [];

  const workExperienceList = toArray(
    getSettingByKey(settings, "total_work_experiences")?.value,
    "\n"
  );

  // Sync state with comma-separated values in URL on load/change
  useEffect(() => {
    if (workExperiencesParam) {
      setChecked(workExperiencesParam.split(",").map((s) => s.trim()));
    } else {
      setChecked([]);
    }
  }, [workExperiencesParam]);

  // Handle Multi-Select Checkbox Toggle
  const handleToggle = (value) => {
    window.scrollTo({
      top: 250,
      behavior: "smooth",
    });

    let updatedChecked = [...checked];
    const index = updatedChecked.indexOf(value);

    if (index === -1) {
      updatedChecked.push(value);
    } else {
      updatedChecked.splice(index, 1);
    }

    if (updatedChecked.length > 0) {
      setChecked(updatedChecked);
      // Pass comma-separated values to parent filter handler using plural key
      onFilterChange("workExperiences", updatedChecked.join(","));
    } else {
      setChecked([]);
      handleClearFilter("workExperiences");
    }
  };

  return (
    <div className="accordion-item border rounded-3 shadow-sm overflow-hidden mt-3">
      <h2 className="accordion-header" id="experienceOne">
        <Button
          className={`accordion-button fw-bold bg-white text-dark py-3 px-4 shadow-none d-flex justify-content-between align-items-center ${
            toggleSecond ? "" : "collapsed"
          }`}
          onClick={(e) => {
            e.preventDefault();
            setToggleSecond(!toggleSecond);
          }}
          role="button"
        >
          <span>Work Experience</span>
          {checked.length > 0 && (
            <span className="badge bg-soft-primary text-primary rounded-pill fs-12 px-2 py-1 me-3">
              {checked.length} Selected
            </span>
          )}
        </Button>
      </h2>

      <Collapse isOpen={toggleSecond}>
        <div className="accordion-body bg-white p-4 pt-2">
          <div className="side-title">
            {/* Clear All / All Experiences Checkbox */}
            <div className="form-check d-flex align-items-center py-1 rounded transition-all">
              <input
                className="form-check-input cursor-pointer"
                type="checkbox"
                id="expAll"
                checked={checked.length === 0}
                onChange={() => {
                  setChecked([]);
                  handleClearFilter("workExperiences");
                }}
              />
              <Label
                className={`form-check-label ms-2 cursor-pointer w-100 ${
                  checked.length === 0 ? "text-dark fw-semibold" : "text-muted"
                }`}
                htmlFor="expAll"
              >
                All Experiences
              </Label>
            </div>

            {/* Dynamic Mapped Experience Checkboxes */}
            {workExperienceList?.map((item, index) => {
              const isSelected = checked.includes(item);
              return (
                <div
                  className="form-check d-flex align-items-center py-1 mt-2 rounded transition-all"
                  key={index}
                >
                  <Input
                    className="form-check-input cursor-pointer"
                    type="checkbox"
                    id={`expCheck-${index}`}
                    checked={isSelected}
                    onChange={() => handleToggle(item)}
                  />
                  <Label
                    className={`form-check-label ms-2 cursor-pointer w-100 ${
                      isSelected ? "text-dark fw-semibold" : "text-muted"
                    }`}
                    htmlFor={`expCheck-${index}`}
                  >
                    {item}
                  </Label>
                </div>
              );
            })}
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default WorkExperience;
